import { useEffect,useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Select } from "flowbite-react";
import  useOrganizationService from '../../../../services/organization';
import { useJwt } from "../../../../helpers/common";
import { HiBadgeCheck } from "react-icons/hi";
import OnboardingCarousel from "../OnboardingCarousel";


const sizeData = [
  {
      value:"Only Me",
      label:"Only Me"
  },
  {
      value:"2-5",
      label:"2-5"
  },
  {
      value:"6-10",
      label:"6-10"
  },
  {
      value:"11-15",
      label:"11-15"
  },
  {
      value:"16-25",
      label:"16-25"
  },
  {
      value:"26-50",
      label:"26-50"
  },
  {
      value:"51-100",
      label:"51-100"
  },
  {
      value:"101-200",
      label:"101-200"
  },
  {
      value:"200+",
      label:"200+"
  },
];
const departments = [
  {
      value:"Software Development",
      label:"Software Development"
  },
  {
      value:"Design & Creative",
      label:"Design & Creative"
  },
  {
      value:"Sales & CRM",
      label:"Sales & CRM"
  },
  {
      value:"HR & Recruiting",
      label:"HR & Recruiting"
  },
];

const teamSizeData = [
  {
      value:"Only Me",
      label:"Only Me"
  },
  {
      value:"2-5",
      label:"2-5"
  },
  {
      value:"6-10",
      label:"6-10"
  },
  {
      value:"11-15",
      label:"11-15"
  },
  {
      value:"16-25",
      label:"16-25"
  },
  {
      value:"26-50",
      label:"26-50"
  },
  {
      value:"51-100",
      label:"51-100"
  },
  {
      value:"101-200",
      label:"101-200"
  },
  {
      value:"200+",
      label:"200+"
  },
];

const roles  = [
  {
      label:"c-level",
      value:"C-Level"
  },
  {
      label:"vp",
      value:"VP"
  },
  {
      label:"director",
      value:"Director"
  },
  {
      label:"teamleader",
      value:"Team Leader"
  },
  {
      label:"teammember",
      value:"Team Member"
  },
  {
      label:"freelancer",
      value:"Freelancer"
  }
]

 const ProfileInfo =  () => {
  const navigate = useNavigate();
  const [userData,setUserData] = useState({role:'',seniority:''});
    const JWTdata = useJwt()
    const { updateOrganization } = useOrganizationService();
    const {orgUpdateSuccess=false,orgUpdateLoading=false} = useSelector((state: any) => state.organization);

    const handleContinue = async () => {
        await updateOrganization(JWTdata.org_id,{current_role:userData.role,seniority:userData.seniority})
    }
    useEffect(()=>{
      (async()=>{
        if(orgUpdateSuccess) {
          window.location.href = "/onboarding/inviteteam";
  
        }
      })()
    },[orgUpdateSuccess])

    const handleChange = (e) => {
        e.preventDefault()
        const {name,value} = e.target;
        const data:any = {...userData}
        data[name] = value
        setUserData(data);
    }
    const handleSkipClick = () =>{
      window.location.href= "/onboarding/inviteteam"
    }

    return (
        <div className={`grid grid-cols-2 gap-5  h-full w-full`}>
         <div className="p-2 w-full h-[100vh]">
              <OnboardingCarousel />
        </div>
            
            <div tabIndex={-1} aria-hidden="true" className="flex flex-col items-center h-full justify-center relative w-full py-24 px-40 overflow-auto" >
            <div onClick={handleSkipClick} className=" dark:text-white text-gray-600 text-sm font-light leading-tight absolute top-10 right-10 cursor-pointer" >Skip</div>
                <div className="relative w-full max-w-2xl h-ful">
                <div className="opacity-50 text-center dark:text-white text-gray-600 text-lg font-normal leading-7 mb-2">Hey, {JWTdata?.username}</div>
                <div className="text-center dark:text-white text-gray-600 text-2xl font-normal leading-9 mb-8">Now we are setting up<br/>your organization</div>
                <div className="w-full h-5 justify-start items-center gap-4 inline-flex">
                    <div className="w-20 self-stretch rounded-md justify-center items-center gap-1.5 flex">
                      <div className="w-5 h-5 relative" />
                      <div className="text-gray-400 text-base font-medium leading-tight">Step 1</div>
                    </div>
                    <div className="grow shrink basis-0 h-px border border-gray-700"></div>
                    <div className="w-18 self-stretch justify-center items-center gap-1.5 flex">
                    <div className="relative" ><HiBadgeCheck className=" text-blue-500" /></div>
                      <div className=" text-blue-500 text-base font-medium leading-tight">Step 2</div>
                    </div>
                    <div className="grow shrink basis-0 h-px border border-gray-700"></div>
                    <div className="w-18 self-stretch rounded-md justify-center items-center gap-1.5 flex">
                    
                      <div className=" text-gray-400 text-base font-medium leading-tight">Step 3</div>
                    </div>
                  </div>
                    <div className="relative pr-4 pl-4 bg-white w-full dark:bg-[#111928] sm:p-5">
                        <form action="#">
                            {/* <div className="gap-4 flex flex-col mb-10">
                                <label htmlFor="name" className="block text-sm font-medium leading-tight text-gray-900 dark:text-white">User Name</label>
                                <input disabled value={JWTdata?.username} type="text" name="name" id="name" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500" placeholder="" required />
                            </div> */}
                            <div className="gap-4 flex flex-col mb-5">
                                <label htmlFor="role" className="block text-sm font-medium leading-tight text-gray-900 dark:text-white">Your Role</label>
                                <Select className="mb-4" name="role" onChange={handleChange}>
                                <option value={''} className="py-1 text-sm text-gray-700 dark:text-gray-200">
                                    {"Select Role..."}
                                  </option>
                                  {roles && roles.map(({ label, value }) => {
                                      return (
                                          <option value={value} className="py-1 text-sm text-gray-700 dark:text-gray-200" key={label}>
                                            {label}
                                          </option>
                                        )
                                  })}
                                </Select>
                            </div>
                            <div className="gap-4 flex flex-col mb-5">
                                <label htmlFor="position" className="block text-sm font-medium leading-tight text-gray-900 dark:text-white">Seniority</label>
                                <Select className="mb-4" name="seniority" onChange={handleChange}>
                                  <option value={''} className="py-1 text-sm text-gray-700 dark:text-gray-200">
                                    {"Select seniority..."}
                                  </option>
                                  {roles && roles.map(({ label, value }) => {
                                      return (
                                          <option value={value} className="py-1 text-sm text-gray-700 dark:text-gray-200" key={label}>
                                            {label}
                                          </option>
                                        )
                                  })}
                                </Select>
                            </div>
                            <div className="grid grid-cols-2 gap-5">
                              <div className="gap-4 flex flex-col mb-5">
                                  <label htmlFor="company_size" className="block text-sm font-medium leading-tight text-gray-900 dark:text-white">Company Size</label>
                                  <Select className="mb-4" name="company_size" onChange={handleChange}>
                                    <option value={''} className="py-1 text-sm text-gray-700 dark:text-gray-200">
                                      {"Select company size"}
                                    </option>
                                    {sizeData && sizeData.map(({ label, value }) => {
                                        return (
                                            <option value={value} className="py-1 text-sm text-gray-700 dark:text-gray-200" key={label}>
                                              {label}
                                            </option>
                                          )
                                    })}
                                  </Select>
                              </div>
                              <div className="gap-4 flex flex-col mb-5">
                                  <label htmlFor="team_size" className="block text-sm font-medium leading-tight text-gray-900 dark:text-white">Team Size</label>
                                  <Select className="mb-4" name="team_size" onChange={handleChange}>
                                    <option value={''} className="py-1 text-sm text-gray-700 dark:text-gray-200">
                                      {"Select team Size"}
                                    </option>
                                    {teamSizeData && teamSizeData.map(({ label, value }) => {
                                        return (
                                            <option value={value} className="py-1 text-sm text-gray-700 dark:text-gray-200" key={label}>
                                              {label}
                                            </option>
                                          )
                                    })}
                                  </Select>
                              </div>
                            </div>
                            <div className="gap-4 flex flex-col mb-5">
                                <label htmlFor="department" className="block text-sm font-medium leading-tight text-gray-900 dark:text-white">Department</label>
                                <Select className="mb-4" name="department" onChange={handleChange}>
                                  <option value={''} className="py-1 text-sm text-gray-700 dark:text-gray-200">
                                    {"Select department"}
                                  </option>
                                  {departments && departments.map(({ label, value }) => {
                                      return (
                                          <option value={value} className="py-1 text-sm text-gray-700 dark:text-gray-200" key={label}>
                                            {label}
                                          </option>
                                        )
                                  })}
                                </Select>
                            </div>
                            
                            <div className="flex ">
                              <div onClick={e=>navigate("/onboarding/orginfo")} className="w-40 h-9 px-5 py-3 bg-gray-800 rounded-lg border border-gray-600 justify-center items-center gap-2 inline-flex cursor-pointer">
                                  <div  className="text-gray-400 text-base font-medium leading-normal ">Back</div>
                              </div>
                              <div onClick={handleContinue} className={`w-40 h-9 ml-auto px-5 py-3 ${orgUpdateLoading ? "bg-blue-500" : "bg-blue-700 "} rounded-lg justify-center items-center gap-2 inline-flex cursor-pointer`}>
                                <div  className="text-white text-base font-medium leading-normal ">Next</div>
                              </div>
                            </div>
                        </form>
                    </div>
                </div>
        </div>
        </div>
    )
}
export default ProfileInfo;
